"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = exports.ErrorOuterContainer = exports.Sidebar = exports.ErrorContainer = exports.FullScreenContainer = exports.Main = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const vars_1 = require("../vars");
const Menu_1 = require("./Menu");
const index_1 = require("./code/index");
const cypress_constants_1 = require("../cypress_constants");
const Components_1 = require("./code/Components");
const Graf_1 = require("../Graf/Graf");
const index_2 = require("../Hierarchy/index");
const graphql_zeus_1 = require("graphql-zeus");
const index_3 = require("../worker/index");
const typestyle_1 = require("typestyle");
const trees_1 = require("../state/containers/trees");
const index_4 = require("../state/containers/index");
exports.Main = typestyle_1.style({
    display: 'flex',
    flexFlow: 'row nowrap',
    height: '100%',
    width: '100%',
    alignItems: 'stretch',
});
exports.FullScreenContainer = typestyle_1.style({
    flex: 1,
    alignSelf: 'stretch',
    height: '100%',
});
exports.ErrorContainer = typestyle_1.style({
    position: 'absolute',
    zIndex: 2,
    top: 0,
    right: 0,
    width: `calc(100% - 40px)`,
    padding: 20,
    margin: 20,
    borderRadius: 4,
    fontSize: 12,
    fontFamily: vars_1.fontFamily,
    letterSpacing: 1,
});
exports.Sidebar = typestyle_1.style({
    alignSelf: 'stretch',
    zIndex: 2,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
});
exports.ErrorOuterContainer = typestyle_1.style({
    width: '100%',
    position: 'relative',
});
let stopCodeFromTreeGeneration = false;
let stopTreeFromCodeGeneration = false;
exports.Editor = ({ readonly, placeholder, schema = {
    code: '',
    libraries: '',
}, initialSizeOfSidebar = vars_1.sizeSidebar, activePane = 'code-diagram', onPaneChange, setSchema, }) => {
    const [sidebarSize, setSidebarSize] = react_1.useState(initialSizeOfSidebar);
    const { menuState, setMenuState } = index_4.useNavigationState();
    const { grafErrors, setGrafErrors, setLockGraf, setCodeErrors } = index_4.useErrorsState();
    const { themed } = index_4.useTheme();
    const { tree, setSnapshots, setUndos, setTree, setLibraryTree, setReadonly, isTreeInitial, setIsTreeInitial, selectedNode, } = trees_1.useTreesState();
    const reset = () => {
        setSnapshots([]);
        setUndos([]);
        setGrafErrors(undefined);
    };
    const generateSchemaFromTree = () => {
        if (!tree) {
            return;
        }
        if (tree.nodes.length === 0) {
            if (schema.code !== '') {
                setSchema(Object.assign(Object.assign({}, schema), { code: '' }));
            }
            return;
        }
        try {
            const graphql = graphql_zeus_1.TreeToGraphQL.parse(tree);
            if (graphql !== schema.code || ((grafErrors === null || grafErrors === void 0 ? void 0 : grafErrors.length) || 0) > 0) {
                index_3.Workers.validate(graphql, schema.libraries).then((errors) => {
                    if (errors.length > 0) {
                        setGrafErrors([...new Set(errors.map((e) => e.text))].join('\n\n'));
                        return;
                    }
                    setGrafErrors(undefined);
                    setSchema(Object.assign(Object.assign({}, schema), { code: graphql }));
                });
            }
        }
        catch (error) {
            setGrafErrors(error.message);
            return;
        }
    };
    const generateTreeFromSchema = () => {
        if (!schema.code) {
            setTree({ nodes: [] });
            return;
        }
        try {
            if (schema.libraries) {
                const excludeLibraryNodesFromDiagram = graphql_zeus_1.Parser.parse(schema.libraries);
                const parsedResult = graphql_zeus_1.Parser.parse(schema.code, [], schema.libraries);
                setTree({
                    nodes: parsedResult.nodes.filter((n) => !excludeLibraryNodesFromDiagram.nodes.find((eln) => eln.name === n.name && eln.data.type === n.data.type)),
                });
            }
            else {
                setTree(graphql_zeus_1.Parser.parse(schema.code));
            }
        }
        catch (error) {
            index_3.Workers.validate(schema.code, schema.libraries).then((errors) => {
                setCodeErrors(errors);
                setLockGraf(!!errors.length);
            });
        }
    };
    react_1.useEffect(() => {
        setReadonly(!!readonly);
    }, [readonly]);
    react_1.useEffect(() => {
        if (schema.libraries) {
            setLibraryTree(graphql_zeus_1.Parser.parse(schema.libraries));
        }
        else {
            setLibraryTree({ nodes: [] });
        }
        reset();
    }, [schema.libraries]);
    react_1.useEffect(() => {
        setMenuState(activePane);
    }, [activePane]);
    react_1.useEffect(() => {
        if (stopTreeFromCodeGeneration) {
            stopTreeFromCodeGeneration = false;
            return;
        }
        stopCodeFromTreeGeneration = true;
        generateTreeFromSchema();
    }, [schema.code]);
    react_1.useEffect(() => {
        if (isTreeInitial) {
            setIsTreeInitial(false);
            return;
        }
        if (stopCodeFromTreeGeneration) {
            stopCodeFromTreeGeneration = false;
            return;
        }
        stopTreeFromCodeGeneration = true;
        generateSchemaFromTree();
    }, [tree]);
    return (react_1.default.createElement("div", { "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'name'), className: exports.Main, onKeyDown: (e) => {
            if (e.key.toLowerCase() === 'f' && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
            }
        } },
        react_1.default.createElement(Menu_1.Menu, { activePane: menuState, setActivePane: (pane) => {
                setMenuState(pane);
                if (onPaneChange) {
                    onPaneChange(pane);
                }
            } }),
        (menuState === 'code' || menuState === 'code-diagram') && (react_1.default.createElement(Components_1.DynamicResize, { disabledClass: menuState === 'code' ? exports.FullScreenContainer : undefined, resizeCallback: (e, r, c, w) => {
                setSidebarSize(c.getBoundingClientRect().width);
            }, width: menuState === 'code' ? '100%' : sidebarSize },
            react_1.default.createElement("div", { className: classnames_1.default(themed('Sidebar')(exports.Sidebar), {
                    [exports.FullScreenContainer]: menuState === 'code',
                }), "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'sidebar', 'name') }, (menuState === 'code' || menuState === 'code-diagram') && (react_1.default.createElement(index_1.CodePane, { size: menuState === 'code' ? 100000 : sidebarSize, onChange: (v) => setSchema(Object.assign(Object.assign({}, schema), { code: v })), schema: schema.code, libraries: schema.libraries, placeholder: placeholder, readonly: readonly, scrollTo: selectedNode && `${selectedNode.type.name} ${selectedNode.name}` }))))),
        (menuState === 'diagram' || menuState === 'code-diagram') && (react_1.default.createElement("div", { className: exports.ErrorOuterContainer },
            grafErrors && react_1.default.createElement("div", { className: themed('ErrorContainer')(exports.ErrorContainer) }, grafErrors),
            react_1.default.createElement(Graf_1.Graf, null))),
        menuState === 'hierarchy' && react_1.default.createElement(index_2.Hierarchy, null)));
};
